// Constants.
import * as StatsChartsConstants from 'constants/StatsChartsConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as PayProductsConstants from 'constants/PayProductsConstants';

const initialState = {
  isFetched: false,
  isFetching: false,
  chartsFlow: {},
};

export default function chartsFlow(state = initialState, action = {}) {
  switch (action.type) {
    case StatsChartsConstants.LOAD_CHARTS_FLOW_REQUEST:
      return {
        ...state,
        isFetched: initialState.isFetched,
        isFetching: true,
        chartsFlow: initialState.chartsFlow,
      };
    case StatsChartsConstants.LOAD_CHARTS_FLOW_SUCCESS: {
      const locale = action.locale;
      const chartsFlowItems = { ...action.chartsFlow };
      const chartsFlow = { };

      Object.keys(chartsFlowItems).map((chartsFlowKey) => {
        const chartsFlowItem = chartsFlowItems[chartsFlowKey];
        chartsFlow[chartsFlowItem.id] = chartsFlowItem;

        if (chartsFlowItem.title !== undefined) {
          chartsFlow[chartsFlowItem.id].title = chartsFlowItem.title[locale];
        }
        if (chartsFlowItem.description !== undefined) {
          chartsFlow[chartsFlowItem.id].description = chartsFlowItem.description[locale];
        }
        if (chartsFlowItem.label !== undefined) {
          chartsFlow[chartsFlowItem.id].label = chartsFlowItem.label[locale];
        }
        if (chartsFlowItem.unit.metric_label !== undefined) {
          chartsFlow[chartsFlowItem.id].unit.metric_label = chartsFlowItem.unit.metric_label[locale];
        }

        if (chartsFlowItem.unit.imperial_label !== undefined) {
          chartsFlow[chartsFlowItem.id].unit.imperial_label = chartsFlowItem.unit.imperial_label[locale];
        }

        chartsFlow[chartsFlowItem.id].categories = [];
        if (chartsFlowItem.category !== undefined) {
          chartsFlowItem.category.map((categoryItem) => {
            chartsFlow[chartsFlowItem.id].categories.push({
              id: categoryItem.id,
              title: categoryItem.title[locale],
              order: categoryItem.order_item,
              order_category: categoryItem.order_category,
            });
          });
        }
        // delete chartsFlow[chartsFlowItem.id].category;

        chartsFlow[chartsFlowItem.id].sources = [];
        if (chartsFlowItem.source !== undefined && chartsFlowItem.source.length > 0) {
          chartsFlowItem.source.map((source) => {
            if (source.welltory !== undefined) {
              const welltorySource = { ...source.welltory };
              if (welltorySource.name !== undefined) {
                welltorySource.name = welltorySource.name[locale];
              }
              else {
                welltorySource.name = chartsFlow[chartsFlowItem.id].title;
              }

              const regex = /\d+/g;
              const matches = welltorySource.url.match(regex);
              if (matches.length > 0) {
                welltorySource.id = parseInt(matches[1]);
              }

              chartsFlow[chartsFlowItem.id].sources.push(welltorySource);
            }
          });
        }
        // delete chartsFlow[chartsFlowItem.id].source;

      });

      return {
        ...state,
        isFetched: true,
        isFetching: false,
        chartsFlow: chartsFlow,
      };
    }

    case PayProductsConstants.PAY_PRODUCT_SUCCESS:
    case AuthConstants.LOGIN_SUCCESS:
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        chartsFlow: {},
      };
    default:
      return state;
  }
}
